import * as THREE from 'three';
import { ID } from "./ID";
import { Env } from './Env';
import { Scene } from './Scene';

export function getCabinetStructure() {
    const json = {};
    //wypisz wszystkie szafki

    for (const index of ID.cabinets.items) {
        const cabinet = Scene.scene.getObjectById(index) as THREE.Object3D;
        const cabinetSize = new THREE.Box3().setFromObject(cabinet).getSize(new THREE.Vector3);
        json[cabinet.name] = {
            uuid: cabinet.uuid,
            id: cabinet.id,
            size: {
                x: Math.round(((cabinetSize.x / Env.size_units) + Number.EPSILON) * 100) / 100,
                y: Math.round(((cabinetSize.y / Env.size_units) + Number.EPSILON) * 100) / 100,
                z: Math.round(((cabinetSize.z / Env.size_units) + Number.EPSILON) * 100) / 100
            },
            rotation: { x: cabinet.rotation.x / (Math.PI / 180), y: cabinet.rotation.y / (Math.PI / 180), z: cabinet.rotation.z / (Math.PI / 180) },
            quaternion: cabinet.quaternion,
            position: {
                x: Math.round(((cabinet.position.x / Env.size_units) + Number.EPSILON) * 100) / 100,
                y: Math.round(((cabinet.position.y / Env.size_units) + Number.EPSILON) * 100) / 100,
                z: Math.round(((cabinet.position.z / Env.size_units) + Number.EPSILON) * 100) / 100
            },
            children: cabinet.children.length ? {} : undefined,
            size_units: Env.size_units
        };
        //wypisz wszystkie formatki danej szafki
        for (const form of cabinet.children) {
            const formSize = new THREE.Box3().setFromObject(form).getSize(new THREE.Vector3);
            json[cabinet.name].children[form.name] = {
                uuid: form.uuid,
                id: form.id,
                size: {
                    x: Math.round(((formSize.x / Env.size_units) + Number.EPSILON) * 100) / 100,
                    y: Math.round(((formSize.y / Env.size_units) + Number.EPSILON) * 100) / 100,
                    z: Math.round(((formSize.z / Env.size_units) + Number.EPSILON) * 100) / 100
                },
                rotation: form.children.length ? {
                    x: form.children[0].rotation.x / (Math.PI / 180),
                    y: form.children[0].rotation.y / (Math.PI / 180),
                    z: form.children[0].rotation.z / (Math.PI / 180)
                } : {
                    x: form.rotation.x / (Math.PI / 180),
                    y: form.rotation.y / (Math.PI / 180),
                    z: form.rotation.z / (Math.PI / 180),
                },
                quaternion: form.quaternion,
                position: {
                    x: Math.round(((form.position.x / Env.size_units) + Number.EPSILON) * 100) / 100,
                    y: Math.round(((form.position.y / Env.size_units) + Number.EPSILON) * 100) / 100,
                    z: Math.round(((form.position.z / Env.size_units) + Number.EPSILON) * 100) / 100
                },
                accessories: (form.children.length && form.children[1].children.length) ? {} : undefined
            };
            //wypisz wszystkie akcesoria
            if (form.children.length && form.children[1].children.length) {
                for (const accessories of form.children[1].children) {
                    const accessoriesSize = new THREE.Box3().setFromObject(accessories).getSize(new THREE.Vector3);
                    json[cabinet.name].children[form.name].accessories[accessories.name] = {
                        uuid: accessories.uuid,
                        id: accessories.id,
                        size: {
                            x: Math.round(((accessoriesSize.x / Env.size_units) + Number.EPSILON) * 100) / 100,
                            y: Math.round(((accessoriesSize.y / Env.size_units) + Number.EPSILON) * 100) / 100,
                            z: Math.round(((accessoriesSize.z / Env.size_units) + Number.EPSILON) * 100) / 100
                        },
                        rotation: { x: accessories.rotation.x / (Math.PI / 180), y: accessories.rotation.y / (Math.PI / 180), z: accessories.rotation.z / (Math.PI / 180) },
                        quaternion: accessories.quaternion,
                        position: {
                            x: Math.round(((accessories.position.x / Env.size_units) + Number.EPSILON) * 100) / 100,
                            y: Math.round(((accessories.position.y / Env.size_units) + Number.EPSILON) * 100) / 100,
                            z: Math.round(((accessories.position.z / Env.size_units) + Number.EPSILON) * 100) / 100
                        }
                    };
                }
            }
        }
    }
    // console.log(json);
    return json;
}